import { ValidateServiceTitanBusinessUnitMappingsResponse } from "./types";
import axiosInstance from "../axiosInstance";

export const validateServiceTitanBusinessUnitMappings = async (
  companyUuid: string,
): Promise<ValidateServiceTitanBusinessUnitMappingsResponse> => {
  const response =
    await axiosInstance.get<ValidateServiceTitanBusinessUnitMappingsResponse>(
      `/api/private/companies/${companyUuid}/service-titan/business-units/trade-mappings/validate`,
    );
  return response.data;
};
